/* ============================================================
   JOANINHA — JS global (vanilla, sem dependências)
   ============================================================ */
(function () {
  "use strict";

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Dialogs (cart drawer + mobile menu) ---------- */
  function openDialogEl(dlg) {
    if (!dlg) return;
    if (typeof dlg.showModal === "function") dlg.showModal();
    else dlg.setAttribute("open", "");
    document.body.style.overflow = "hidden";
  }
  function closeDialogEl(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === "function") dlg.close();
    else dlg.removeAttribute("open");
    document.body.style.overflow = "";
  }
  function bindDialog(dlg) {
    if (!dlg || dlg.dataset.dialogBound) return;
    dlg.dataset.dialogBound = "1";
    dlg.addEventListener("close", () => { document.body.style.overflow = ""; });
    dlg.addEventListener("click", (e) => { if (e.target === dlg) closeDialogEl(dlg); });
  }
  function openCart() { const d = $("#cart-drawer"); bindDialog(d); openDialogEl(d); }
  function closeCart() { const d = $("#cart-drawer"); bindDialog(d); closeDialogEl(d); }
  window.Joaninha = window.Joaninha || {};
  Object.assign(window.Joaninha, { openCart, closeCart, refreshCart, showCartFeedback: showCartAlert });

  function renderCartItems(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const items = $("#cart-items", doc);
    const subtotal = $("#cart-subtotal", doc);
    const n = (items && (items.dataset.cartCount || items.dataset.count)) || "0";
    if (items) {
      const target = $("#cart-items");
      if (target) {
        /* innerHTML já traz o empty state quando count=0; dataset mantém o contador coerente */
        target.innerHTML = items.innerHTML;
        target.dataset.cartCount = n;
      }
    }
    if (subtotal) {
      const t = $("#cart-subtotal");
      if (t) t.innerHTML = subtotal.innerHTML;
    }
    $$("[data-cart-count-badge]").forEach((el) => {
      el.textContent = n;
      el.hidden = n === "0";
    });
    const cartBtn = document.querySelector("[data-cart-open]");
    if (cartBtn) {
      const base = cartBtn.dataset.baseLabel || "Sacola";
      cartBtn.setAttribute("aria-label", n === "0" ? base : base + " — " + n + (n === "1" ? " item" : " itens"));
    }
    const barNew = $("[data-freeship]", doc);
    if (barNew) {
      const barOld = $("#cart-drawer [data-freeship]") || $("[data-freeship]");
      if (barOld) barOld.replaceWith(barNew);
    }
    updateFreeShippingBar();
    document.dispatchEvent(new CustomEvent('cart:rendered'));
  }

  function captureCartFocus() {
    const active = document.activeElement;
    const scope = active?.closest('.cart-page, #cart-drawer');
    if (!scope) return null;
    const line = active.closest('.cart-line');
    return { scope: scope.matches('.cart-page') ? '.cart-page' : '#cart-drawer',
      key: line?.querySelector('[data-quantity-input]')?.dataset.key,
      identity: line?.dataset.cartIdentity, index: $$('.cart-line', scope).indexOf(line),
      action: active.dataset.quantityButton || (active.matches('[data-quantity-input]') ? 'input' : active.matches('[data-cart-remove]') ? 'remove' : null) };
  }
  function restoreCartFocus(state) {
    if (!state) return;
    const scope = $(state.scope);
    if (!scope) return;
    const matched = $$('[data-quantity-input]', scope).find(el => el.dataset.key === state.key);
    const lines = $$('.cart-line', scope);
    const line = matched?.closest('.cart-line') || (state.identity ? lines.find(el => el.dataset.cartIdentity === state.identity) : state.action !== 'remove' ? lines[state.index] : null);
    const input = line?.querySelector('[data-quantity-input]');
    const target = state.action === 'input' ? input : state.action === 'remove'
      ? line?.querySelector('[data-cart-remove]') : line?.querySelector(`[data-quantity-button="${state.action}"]`);
    const fallback = scope.querySelector('[data-quantity-input], .cart-empty a, [data-cart-close]');
    if (state.action) (target || fallback)?.focus({ preventScroll: true });
  }

  /* Both cart surfaces reconcile from server-rendered prices and quantities. */
  async function refreshCart() {
    const page = $('.cart-page');
    const note = page?.querySelector('textarea[name="note"]');
    const draft = note ? { value: note.value, open: note.closest('details')?.open } : null;
    try {
      const cartUrl = window.routes?.cart_url || '/cart';
      const res = await boundedFetch(`${cartUrl}?view=drawer`, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
      if (!res.ok) return false;
      const html = await res.text();
      if (!new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-items')) return false;
      renderCartItems(html);
      if (page) {
        const response = await boundedFetch(cartUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
        if (!response.ok) return false;
        const fresh = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.cart-page');
        if (!fresh) return false;
        page.innerHTML = fresh.innerHTML;
        const newNote = page.querySelector('textarea[name="note"]');
        if (draft && newNote) { newNote.value = draft.value; if (newNote.closest('details')) newNote.closest('details').open = draft.open; }
      }
      return true;
    } catch (_) { return false; }
  }

  const Feedback = window.JoaninhaCartFeedback;
  let cartQueue = Promise.resolve();
  let pendingCartOperations = 0;
  function enqueueCart(operation) {
    pendingCartOperations++;
    setDrawerBusy(true);
    const run = cartQueue.then(operation).finally(() => {
      pendingCartOperations--;
      setDrawerBusy(pendingCartOperations > 0);
    });
    cartQueue = run.catch(() => undefined);
    return run;
  }
  async function boundedFetch(url, options = {}, timeout = 15000) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      const body = await response.text();
      return { ok: response.ok, status: response.status, json: async () => JSON.parse(body), text: async () => body };
    }
    finally { clearTimeout(timer); }
  }
  async function readCartState() {
    const response = await boundedFetch(`${window.routes?.cart_url || '/cart'}.js`, { cache: 'no-store' });
    if (!response.ok) throw new Error('cart-state');
    const cart = await response.json();
    if (!Array.isArray(cart.items) || cart.items.some(item => !Number.isSafeInteger(item.quantity) || item.quantity < 0)) throw new Error('cart-shape');
    return cart;
  }
  function formIdentity(data) {
    const properties = {};
    for (const [key, value] of data.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
    }
    return { id: String(data.get('id') || ''), sellingPlan: String(data.get('selling_plan') || ''), properties };
  }
  function sameProperties(a, b) {
    const entries = value => Object.entries(value || {}).filter(([, item]) => item !== '').sort(([x], [y]) => x.localeCompare(y));
    return JSON.stringify(entries(a)) === JSON.stringify(entries(b));
  }
  function quantityFor(cart, identity) {
    if (!cart) return null;
    return cart.items.filter(item => String(item.variant_id || item.id) === identity.id &&
      String(item.selling_plan_allocation?.selling_plan?.id || '') === identity.sellingPlan &&
      sameProperties(item.properties, identity.properties)).reduce((sum, item) => sum + item.quantity, 0);
  }
  function renderFeedback(el, value) {
    const feedback = typeof value === 'string' ? { message: value, kind: 'error' } : value;
    el.replaceChildren();
    el.hidden = !feedback?.message;
    if (!feedback?.message) return;
    el.dataset.kind = feedback.kind || 'error';
    el.setAttribute('role', feedback.kind === 'success' ? 'status' : 'alert');
    el.setAttribute('aria-atomic', 'true');
    const copy = document.createElement('span'); copy.textContent = feedback.message; el.append(copy);
    if (feedback.action) {
      const link = document.createElement('a');
      link.textContent = Feedback.text(feedback.action === 'reload' ? 'reload' : 'viewCart');
      link.href = feedback.action === 'reload' ? window.location.href : window.routes?.cart_url || '/cart';
      el.append(link);
    }
  }
  function showFormError(form, value) {
    let el = form.querySelector('[data-cart-error]');
    if (!el) {
      el = document.createElement('div'); el.className = 'form-cart-error'; el.dataset.cartError = '';
      form.append(el);
    }
    renderFeedback(el, value);
    const message = typeof value === 'string' ? value : value?.message;
    if (message && value?.kind !== 'success' && !document.querySelector('dialog[open]')) {
      const rect = el.getBoundingClientRect();
      if (rect.top < 100 || rect.bottom > window.innerHeight - 90) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  /* One queue for all theme cart mutations; never retry an uncertain POST. */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    if (form.dataset.cartSubmitting === 'true') return;
    const snapshot = new FormData(form);
    const requested = Number(snapshot.get('quantity') || 1);
    if (!Number.isSafeInteger(requested) || requested < 1) { showFormError(form, Feedback.text('invalidQuantity')); return; }
    form.dataset.cartSubmitting = 'true';
    const btn = form.querySelector('[data-add-button]') || form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    showFormError(form, { message: Feedback.text('loading'), kind: 'success' });
    try {
      await enqueueCart(async () => {
        setDrawerBusy(true); showCartAlert('');
        const identity = formIdentity(snapshot);
        let before;
        try { before = await readCartState(); }
        catch (_) { showFormError(form, Feedback.describe({ notSent: true })); return; }
        let response, payload, network = false;
        try {
          response = await boundedFetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, { method: 'POST', body: snapshot, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          try { payload = await response.json(); } catch (_) { /* Reconcile instead of showing HTML/technical text. */ }
        } catch (_) { network = true; }
        const [after, rendered] = await Promise.all([readCartState().catch(() => null), refreshCart()]);
        const result = Feedback.describe({ operation: 'add', requested, before: quantityFor(before, identity), actual: quantityFor(after, identity), rendered,
          ok: response?.ok && !!payload, status: response?.status, payload, network });
        showFormError(form, result);
        if (result.kind === 'success' || result.key === 'partial') {
          if (window.JoaninhaCart?.settings?.drawer) { showCartAlert(result); openCart(); }
          else window.location.href = window.routes?.cart_url || '/cart';
        }
      });
    } finally {
      setDrawerBusy(pendingCartOperations > 0); form.dataset.cartSubmitting = 'false';
      if (btn) {
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
        const synced = window.JoaninhaProduct?.syncForm?.(form);
        if (!synced) { btn.disabled = false; if (btn.dataset.label) btn.innerHTML = btn.dataset.label; }
      }
    }
  });

  /* Região de alerta do drawer (fora de #cart-items para sobreviver ao refresh) */
  function showCartAlert(msg) {
    $$('[data-cart-drawer-alert], [data-cart-page-alert]').forEach(el => {
      renderFeedback(el, msg);
    });
  }
  function setDrawerBusy(busy) {
    $$('.cart-page, #cart-drawer').forEach(surface => {
      surface.classList.toggle('is-busy', busy);
      surface.setAttribute('aria-busy', String(busy));
      $$('[data-quantity-button], [data-quantity-input], [name=checkout]', surface).forEach(el => { el.disabled = busy; });
      $$('[data-cart-remove]', surface).forEach(el => el.setAttribute('aria-disabled', String(busy)));
    });
  }
  document.addEventListener('submit', e => {
    if (e.target.closest('#cart-drawer.is-busy, .cart-page.is-busy')) {
      e.preventDefault(); showCartAlert(Feedback.text('wait'));
    }
  });
  function changeLine(key, quantity) {
    const focus = captureCartFocus();
    setDrawerBusy(true);
    return enqueueCart(() => doChangeLine(key, quantity, focus));
  }
  async function doChangeLine(key, quantity, focus) {
    let result;
    showCartAlert({ message: Feedback.text('loading'), kind: 'success' });
    try {
      let before;
      try { before = await readCartState(); }
      catch (_) { result = Feedback.describe({ notSent: true }); return; }
      const old = before.items.find(item => item.key === key);
      if (!old) {
        await refreshCart();
        result = { message: Feedback.text('invalidVariant'), kind: 'warning', action: 'reload' }; return;
      }
      let response, payload, network = false;
      try {
        response = await boundedFetch(`${window.routes?.cart_change_url || '/cart/change'}.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: key, quantity })
        });
        try { payload = await response.json(); } catch (_) { /* Confirm the actual cart below. */ }
      } catch (_) { network = true; }
      const [after, rendered] = await Promise.all([readCartState().catch(() => null), refreshCart()]);
      const exact = after?.items.find(item => item.key === key);
      const actual = after ? (exact ? exact.quantity : quantityFor(after, { id: String(old.variant_id || old.id), sellingPlan: String(old.selling_plan_allocation?.selling_plan?.id || ''), properties: old.properties || {} })) : null;
      result = Feedback.describe({ operation: 'change', requested: quantity, before: old.quantity, actual, rendered,
        ok: response?.ok && Array.isArray(payload?.items), status: response?.status, payload, network });
    } finally {
      showCartAlert(result || Feedback.text('unknown')); requestAnimationFrame(() => restoreCartFocus(focus));
    }
  }
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-quantity-button]');
    if (button) {
      if (button.disabled) return;
      const input = button.parentElement.querySelector('[data-quantity-input]');
      if (!input) return;
      let value = Number(input.value);
      if (!Number.isInteger(value) || value < 0 || input.value.trim() === '') value = Number(input.defaultValue) || 1;
      input.value = button.dataset.quantityButton === 'plus' ? value + 1 : Math.max(0, value - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      if (remove.getAttribute('aria-disabled') === 'true') return;
      if (remove.dataset.cartRemove) changeLine(remove.dataset.cartRemove, 0);
    }
  });
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-quantity-input]');
    if (!input || input.disabled || !input.closest('.cart-page, #cart-drawer')) return;
    const quantity = Number(input.value);
    if (input.value.trim() === '' || !Number.isSafeInteger(quantity) || quantity < 0) {
      input.value = input.defaultValue || '1';
      showCartAlert(Feedback.text('invalidQuantity'));
      return;
    }
    if (input.dataset.key) changeLine(input.dataset.key, quantity);
  });

  /* Cart drawer close on backdrop / esc handled by <dialog> */

  /* ---------- Mobile menu ---------- */
  document.addEventListener("click", (e) => {
    const open = e.target.closest("[data-menu-open]");
    if (open) {
      const menu = $("#mobile-menu");
      bindDialog(menu);
      openDialogEl(menu);
    }
    const close = e.target.closest("[data-menu-close]");
    if (close) {
      const menu = $("#mobile-menu");
      bindDialog(menu);
      closeDialogEl(menu);
    }
    const opener = e.target.closest("[data-cart-open]");
    if (opener) { e.preventDefault(); openCart(); }
    const closer = e.target.closest("[data-cart-close]");
    if (closer) { closeCart(); }
    /* Submenu disclosure */
    const summary = e.target.closest("[data-disclosure] > summary");
    if (summary) {
      e.preventDefault(); // este handler controla a abertura; não alternar novamente pela ação nativa
      const details = summary.parentElement;
      const open = !details.open;
      $$("[data-disclosure][open]").forEach((d) => { if (d !== details) d.removeAttribute("open"); });
      details.open = open;
      if (open && details.matches('.header__search')) {
        requestAnimationFrame(() => {
          if (details.open && document.activeElement === summary) $("[data-search-input]", details)?.focus();
        });
      }
    }
  });

  /* ---------- Preferência de movimento para revelação de conteúdo ---------- */
  const motionPreference = window.matchMedia("(prefers-reduced-motion: reduce)");
  const onMotionChange = (listener) => {
    if (motionPreference.addEventListener) motionPreference.addEventListener("change", listener);
    else if (motionPreference.addListener) motionPreference.addListener(listener);
  };
  /* ---------- Reveal: conteúdo não depende de JavaScript para aparecer ---------- */
  if ("IntersectionObserver" in window && !motionPreference.matches && !window.Shopify?.designMode) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        io.unobserve(entry.target);
      });
    }, { rootMargin: "0px", threshold: 0.05 });
    const observe = () => $$("[data-reveal]:not(.is-visible)").forEach((el) => {
      const siblings = Array.from(el.parentElement?.children || []).filter((c) => c.matches("[data-reveal]"));
      el.style.transitionDelay = `${Math.min(Math.max(siblings.indexOf(el), 0) * 45, 180)}ms`;
      io.observe(el);
      el.classList.add("is-reveal-pending");
    });
    observe();
    document.addEventListener("shopify:section:load", observe);
    onMotionChange(() => {
      if (!motionPreference.matches) return;
      io.disconnect();
      $$("[data-reveal]").forEach((el) => el.classList.add("is-visible"));
      document.removeEventListener("shopify:section:load", observe);
    });
  }

  /* ---------- Collection facets (auto-submit on change except sort) ---------- */

  /* ---------- Product variant: option selection ----------
     REMOVIDO: a resolução de variantes da PDP é exclusiva do product.js
     (busca selects pelo root [data-product-section]; aqui havia handler
     concorrente que procurava os selects apenas dentro do form). */

  /* ---------- Free shipping bar progress ---------- */
  function updateFreeShippingBar() {
    $$("[data-freeship]").forEach((bar) => {
      const threshold = parseInt(bar.dataset.threshold, 10) || 0;
      const total = parseInt(bar.dataset.total, 10) || 0;
      const fill = $(".freeship__fill, .freeship-bar__fill", bar);
      const text = $("[data-freeship-text]", bar);
      if (threshold === 0) return;
      const pct = Math.min(100, Math.round((total / threshold) * 100));
      if (fill) fill.style.width = pct + "%";
      bar.classList.toggle("is-reached", total >= threshold);
      if (text) {
        if (total >= threshold) {
          text.textContent = text.dataset.reached || "Meta de valor atingida. Confirme a disponibilidade do frete grátis para seu CEP no checkout.";
        } else {
          const remaining = (threshold - total) / 100;
          text.textContent = (text.dataset.progress || "Faltam [amount] para a meta de frete grátis. Confirme as condições para seu CEP no checkout.").replace("[amount]", remaining.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
        }
      }
    });
  }
  updateFreeShippingBar();
  window.Joaninha.updateFreeShippingBar = updateFreeShippingBar;
  document.addEventListener("cart:updated", updateFreeShippingBar);

  /* ---------- Cart note / drawer refresh signal ---------- */
  document.addEventListener("cart:updated", () => refreshCart());

  /* ---------- Search dropdown ---------- */
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("[data-search-form]");
    if (!form) return;
    const input = form.querySelector("[data-search-input]");
    if (input && !input.value.trim()) { e.preventDefault(); input.focus(); }
  });

  /* ---------- Predictive search (UX-04) ---------- */
  (function predictiveSearch() {
    const escapeHtml = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => (
      { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
    ));
    const states = new Map();
    let nextId = 0;
    function stateFor(input) {
      if (states.has(input)) return states.get(input);
      const form = input.closest('form');
      if (!form) return null;
      const list = document.createElement('div');
      list.id = 'predictive-search-results-' + (++nextId);
      list.className = 'header__search-results';
      list.dataset.predictiveResults = '';
      list.setAttribute('role', 'region');
      list.setAttribute('aria-label', 'Sugestões de produtos');
      list.hidden = true;
      input.setAttribute('aria-controls', list.id);
      form.insertAdjacentElement('afterend', list);
      const state = { input, form, list, timer: null, controller: null, version: 0, query: '' };
      states.set(input, state);
      return state;
    }
    function close(state) {
      clearTimeout(state.timer);
      if (state.controller) { state.query = ''; state.list.innerHTML = ''; }
      state.controller?.abort();
      state.version++;
      state.list.hidden = true;
    }
    function seeAll(state, query) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ps-all';
      button.dataset.psSeeAll = '';
      button.textContent = 'Ver todos os resultados para “' + query + '”';
      button.addEventListener('click', () => state.form.requestSubmit ? state.form.requestSubmit() : state.form.submit());
      state.list.appendChild(button);
    }
    document.addEventListener('input', (e) => {
      const input = e.target.closest('[data-search-input]');
      if (!input) return;
      const state = stateFor(input);
      if (!state) return;
      states.forEach(close); // cancela antes do debounce, inclusive o outro campo responsivo
      const { form, list } = state;
      const details = form.closest('details');
      if (details) details.open = true;
      const query = input.value.trim();
      list.innerHTML = '';
      if (query.length < 2) { list.innerHTML = ''; state.query = ''; return; }
      const version = state.version;
      state.query = query;
      state.timer = setTimeout(async () => {
        const controller = new AbortController();
        state.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 8000);
        const current = () => state.version === version && input.value.trim() === query;
        list.hidden = false;
        list.innerHTML = '<p class="ps-status" role="status">Buscando…</p>';
        try {
          const url = `${window.routes?.predictive_search_url || '/search/suggest'}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[limit_scope]=each`;
          const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: controller.signal });
          if (!res.ok) throw new Error('predictive-search');
          const data = await res.json();
          if (!current()) return;
          let products = data?.resources?.results?.products || [];
          if (!products.length) {
            // Same Shopify catalog search used by the full results page.
            const fallback = await fetch(`${window.routes?.search_url || '/search'}?type=product&q=${encodeURIComponent(query)}&view=suggestions`, { signal: controller.signal });
            if (fallback.ok) {
              const matches = await fallback.json();
              if (Array.isArray(matches)) products = matches;
            }
          }
          if (!current()) return;
          list.innerHTML = products.length ? products.map((p) => {
            const title = escapeHtml(String(p.title || '').replace(/<[^>]*>/g, ''));
            const href = escapeHtml(String(p.url || '#'));
            const img = p.featured_image?.url ? `${p.featured_image.url}${p.featured_image.url.includes('?') ? '&' : '?'}width=112` : null;
            const price = p.price_min !== undefined
              ? Number(p.price_min).toLocaleString('pt-BR', { style: 'currency', currency: window.shopCurrency || 'BRL' }) : null;
            return `<a href="${href}" class="ps-item" aria-label="${title}">
              ${img ? `<img src="${escapeHtml(img)}" alt="" width="56" height="56" loading="lazy">` : ''}
              <span class="ps-item__body"><span class="ps-item__title">${title}</span>${price ? `<span class="ps-item__price">${price}</span>` : ''}</span>
            </a>`;
          }).join('') : '<p class="ps-status" role="status">Veja os produtos disponíveis na pesquisa completa.</p>';
          seeAll(state, query);
        } catch (_) {
          if (!current()) return;
          list.innerHTML = '<p class="ps-status" role="status">As sugestões estão indisponíveis. Você pode continuar pela pesquisa completa.</p>';
          seeAll(state, query);
        } finally {
          clearTimeout(timeout);
          if (state.controller === controller) state.controller = null;
        }
      }, 250);
    });
    document.addEventListener('focusin', (e) => {
      const input = e.target.closest('[data-search-input]');
      if (!input) return;
      states.forEach((state, field) => { if (field !== input) close(state); });
      const state = states.get(input);
      if (state && state.query === input.value.trim() && state.list.children.length) state.list.hidden = false;
      else if (input.value.trim().length >= 2) input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    document.addEventListener('click', (e) => {
      states.forEach((state) => {
        if (!state.form.contains(e.target) && !state.list.contains(e.target)) close(state);
      });
      if (!e.target.closest('.header__search, .header__mobile-search')) {
        const details = document.querySelector('.header__search[data-disclosure]');
        if (details) details.open = false;
      }
    });
    document.addEventListener('focusout', (e) => {
      const details = e.target.closest('.header__search[open]');
      if (!details) return;
      requestAnimationFrame(() => {
        if (details.contains(document.activeElement)) return;
        details.open = false;
        states.forEach((state) => { if (details.contains(state.form)) close(state); });
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      // Fecha sugestões sem apagar a consulta pelo comportamento nativo do searchbox.
      if (Array.from(states.values()).some(state => !state.list.hidden)) e.preventDefault();
      states.forEach(close);
      const details = e.target.closest('.header__search[open]');
      if (details) { details.open = false; details.querySelector('summary')?.focus(); }
    });
  })();

  /* ---------- Search page sort (UX-06) ---------- */
  document.addEventListener("change", (e) => {
    const sel = e.target.closest("[data-search-sort]");
    if (!sel) return;
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", sel.value);
    url.searchParams.delete("page");
    window.location.href = url.toString();
  });

  /* ---------- Year in footer ---------- */
  $$("[data-year]").forEach((el) => { el.textContent = new Date().getFullYear(); });
})();
